import EmailViewSummary from "@/domain/entities/dashboard/EmailViewSummary";
import CategoryTag from "@/domain/enums/CategoryTag";
import { ViewSummary } from "@cs_teamwaydev/mailvista-sdk_react";

const emailViewSummaryMapper = (emailViewSummary: ViewSummary) =>
    new EmailViewSummary({
        id: emailViewSummary.viewId,
        title: emailViewSummary.title,
        icon: emailViewSummary.icon,
        iconColor: emailViewSummary.iconColor,
        mailCount: emailViewSummary.mailCount,
        categoryRepartition: emailViewSummary.categoryRepartition.map(
            (categoryRepartition) => ({
                categoryId: categoryRepartition.categoryId,
                percentage: categoryRepartition.percentage,
                title: categoryRepartition.title as CategoryTag,
            }),
        ),
    });

export default emailViewSummaryMapper;
